import { useDocsDataModelStore } from "@/models/docs-data/docsData";
import { removeEnvironmentBuiltinByDocsId } from "@/shared/constant/local-storage/use-environment/UseBuiltinEnvironmentStorage";
import { removeEnvironmentsByDocsId } from "@/shared/constant/local-storage/use-environment/UseEnvironmentStorage";
import React from "react";

export function useRemoveEnvironments() {
  const persistEnvVariables = useDocsDataModelStore((x) => x.docsBaseConfig.persistEnvVariables);
  const docsId = useDocsDataModelStore((x) => x.docsIdTypeData.onlineId);

  React.useEffect(() => {
    if (!persistEnvVariables) {
      removeEnvironmentsByDocsId(docsId);
      removeEnvironmentBuiltinByDocsId(docsId);
    }
  }, [persistEnvVariables, docsId]);
}
